import {useSelector} from 'react-redux';
import React from 'react';

import {useI18n} from '../../../data/hooks/i18nHooks';
import styles from './APIConnectionWarning.module.scss';

const APIConnectionWarning = props => {
    const {connectionWasChecked, hasAPIConnection} = useSelector(state => state.session),
        i18n = useI18n();

    if (!connectionWasChecked || hasAPIConnection) return null;

    return <div className={styles.APIConnectionWarning}>{i18n['message.networkerror']}</div>;
};

export default APIConnectionWarning;
